import { useCallback } from 'react';
import {
    ExtendVenueFlags,
    RequestResultsStatus,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { EAskFowReviewFormSectionType } from './types';
import { useAskFowReviewFormSchema } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/use-ask-for-review-flow-config';
import { ChipListOptionType } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/components/chip-list/chip-list';

type AskForReviewGetOptionsProps = {
    status: RequestResultsStatus;
    entityId: string | undefined;
    flag: ExtendVenueFlags | undefined;
};

export const useAskForReviewOptions = () => {
    const { getFormsConfig } = useAskFowReviewFormSchema();

    const getOptions = useCallback(
        (props: AskForReviewGetOptionsProps) => {
            const config = getFormsConfig(props);
            return config.map(
                ({ title, type, testId }) =>
                    ({
                        label: title,
                        value: type,
                        testId,
                    } as ChipListOptionType<EAskFowReviewFormSectionType>),
            );
        },
        [getFormsConfig],
    );

    return {
        getOptions,
    };
};
